import axios from 'axios';
import {
  isSqlCaptureRequested,
  requestSqlCapture
} from 'utils/sql-capture-header';
import { sqlCaptureSetting } from 'utils/sql-capture-setting';
import { isSystemsQueryRequest } from 'utils/systems-query-request';
import { systemsQuerySession } from 'utils/systems-query-session';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SYSTEM_SELECTOR_API_URL,
  withCredentials: true
});

axiosInstance.interceptors.request.use((config) => {
  if (sqlCaptureSetting.isEnabled() && isSystemsQueryRequest(config)) {
    requestSqlCapture(config.headers);
  }
  return config;
});

axiosInstance.interceptors.response.use((response) => {
  if (
    isSystemsQueryRequest(response.config) &&
    isSqlCaptureRequested(response.config.headers)
  ) {
    systemsQuerySession.markRun();
  }
  return response;
});

export default axiosInstance;
